import { createSlice } from '@reduxjs/toolkit'
import Config from '../../Core/Config'

export const SET_SELECTED_TEST_REVISIONS = 'ui/testrevisions/setSelected'
export const UNSELECT_TEST_REVISION = 'ui/testrevisions/unselect'
export const ACTIVATE_SHORTCUT = 'ui/testrevisions/activateShortcut'
export const DISACTIVATE_SHORTCUT = 'ui/testrevisions/disactivateShortcut'

const testRevisionsUiSlice = createSlice({
  name: 'testRevisions',
  initialState: {
    selectedTestRevisions: [],
    activeShortcut: null,
    menu: {
      expanded: Config.ui.defaultExpandedRightMenu,
    },
  },
  reducers: {
    init: (state) => {
      return { ...state, initing: true }
    },
    setSelectedTestRevisions: (state, action) => {
      state.selectedTestRevisions = action.payload
    },
    unselectTestRevision: (state, action) => {
      state.selectedTestRevisions = state.selectedTestRevisions.filter((tc) => tc.id !== action.payload.id)
    },
    activateShortcut: (state, action) => {
      state.activeShortcut = action.payload
    },
    disactivateShortcut: (state) => {
      state.activeShortcut = null
    },
    toggleMenuExpanded: (state) => {
      state.menu.expanded = !state.menu.expanded
    },
  },
})

export const {
  setSelectedTestRevisions,
  unselectTestRevision,
  activateShortcut,
  disactivateShortcut,
  toggleMenuExpanded,
} = testRevisionsUiSlice.actions
export default testRevisionsUiSlice.reducer

export const selectSelectedTestRevisions = (state) => state.ui.testRevisions.selectedTestRevisions
export const selectActiveShorcut = (state) => state.ui.testRevisions.activeShortcut
export const selectMenuExpanded = (state) => state.ui.testRevisions.menu.expanded
